type CheckboxFieldProps = {
	label: string;
	checked: boolean;
	onChange: (checked: boolean) => void;
	id?: string;
};

export function CheckboxField({
	label,
	checked,
	onChange,
	id,
}: CheckboxFieldProps) {
	const checkboxId = id ?? label.toLowerCase().replace(/[^a-z0-9]+/g, "-");

	return (
		<label className="pf-checkbox" htmlFor={checkboxId}>
			<input
				id={checkboxId}
				type="checkbox"
				checked={checked}
				onChange={(event) => onChange(event.target.checked)}
			/>
			<span>{label}</span>
		</label>
	);
}
